/* eslint-disable */

export enum RelationshipType {
	Package = 1,
	Subitem = 2,
	
}
